import React from 'react';

import { Box, Typography, List, Stack, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { EditNoteParams } from 'src/florence/types/RouterState';

import { ReactComponent as EditIcon } from '../../../../common/assets/icons/edit_icon.svg';
import { FlorencePAGES } from '../../../../common/components/tfa-auth/constants/pages';
import { SaveSheet } from '../../../../common/types/SaveSheet';

import SheetCodeCell from './SheetCodeCell';

type Props = {
  savedSheet: SaveSheet;
};

const SavedSheetsContainer: React.FC<Props> = ({ savedSheet }) => {
  const navigate = useNavigate();

  const editSheet = () => {
    navigate(FlorencePAGES.editSheet, {
      state: {
        note: savedSheet,
      } as EditNoteParams,
    });
  };

  const editNoteV2 = () => {
    navigate(FlorencePAGES.editOPNote, {
      state: {
        note: savedSheet,
      } as EditNoteParams,
    });
  };

  return (
    <Box className='user-content-container'>
      <Stack spacing={2.5}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Typography fontSize='18px'>
            {savedSheet.sheetCodes.length} Code
            {savedSheet.sheetCodes.length === 1 ? '' : 's'}
          </Typography>
          <Box>
            <Button
              onClick={editSheet}
              disableElevation
              color='primary'
              variant='contained'
              startIcon={<EditIcon fill='white' />}
              sx={{
                flexShrink: 0,
                borderRadius: '50px',
                height: '50px',
                mx: '15px',
              }}
            >
              <Typography noWrap color='white'>
                {savedSheet.clinicNote ? 'Edit Clinic Note' : 'Edit Op Note'}
              </Typography>
            </Button>
            <Button
              onClick={editNoteV2}
              disableElevation
              color='primary'
              variant='contained'
              startIcon={<EditIcon fill='white' />}
              sx={{
                flexShrink: 0,
                borderRadius: '50px',
                height: '50px',
                mx: '15px',
              }}
            >
              <Typography noWrap color='white'>
                {savedSheet.clinicNote
                  ? 'Clinic note!!!?!?!?'
                  : 'Edit Op Note V2'}
              </Typography>
            </Button>
          </Box>
        </Box>
        <List>
          <Box>
            {savedSheet.sheetCodes.map((result, index) => (
              <SheetCodeCell key={index} code={result} />
            ))}
          </Box>
        </List>
      </Stack>
    </Box>
  );
};

export default SavedSheetsContainer;
